<template>
  <div>
    <wrapper-preview-category customClass="section-preview_lk">
      <p>
        При нажатии на строку произойдет переход на страницу рапределения мест приема по
        образовательным программам
      </p>
    </wrapper-preview-category>
    <show-error-messages
      v-if="showErrorModal"
      title="Ошибка блокировки"
      :messages="errorMessages"
      @closeErrorModal="showErrorModal = false" />
    <wrapper-preview-category customClass="section-preview_lk" style="position: relative">
      <v-btn :disabled="letBlocked || (getSelectedYear === '2023')" class="blue__v-btn block-btn" @click.stop="blockData">
        {{ !letBlocked ? 'Заблокировать' : 'Заблокировано' }}
      </v-btn>
      <v-btn class="blue__v-btn scan-btn" @click="scanDialog = true">
        Печать/загрузка скана
      </v-btn>
      <div class="d-flex flex-column align-start justify-center mt-15 mb-4">
        <div>
          <p class="mb-0">Форма обучения</p>
          <v-autocomplete
              v-if="filter.sprFo.length !== 0"
            v-model="filter.sprFo"
            :items="sprData.sprFo"
            chips
            color="primary"
            dense
            label="Форма обучения"
            multiple
            small-chips
            solo></v-autocomplete>
        </div>
      </div>
      <grid-table
        :key="type"
        :data-rows="filteredData"
        :headers="tableHeaders.massive"
        :headers-for-rows="tableHeaders.massive"
        :loading-data="tableData.loading"
        :num-cols="tableHeaders.countCells"
        :paint-background="paintBackgroundProp"
        max-table-height="700px"
        @row-action="clickOnRow($event)">
        <template #header-actions="{ row }">
          <div class="d-flex align-center justify-center flex-row">
            <v-btn
              :disabled="letBlocked || (getSelectedYear === '2023')"
              class="blue__v-btn"
              @click.stop="openDialog('action', row)">
              Добавить строку
            </v-btn>
          </div>
        </template>
        <template #actions="{ row }">
          <div class="d-flex align-center justify-center flex-row">
            <v-btn
              v-if="row.ffId > 1"
              :disabled="letBlocked || (getSelectedYear === '2023')"
              :loading="tableData.change.id === row.id && tableData.change.value"
              icon
              @click.stop="openDialog('edit', row)">
              <v-icon color="primary" size="24">mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="row.ffId > 1"
              :disabled="letBlocked || (getSelectedYear === '2023')"
              :loading="tableData.change.id === row.id && tableData.change.value"
              icon
              @click.stop="deleteOrgTableData(row)">
              <v-icon color="primary" size="24">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </grid-table>
    </wrapper-preview-category>
    <universal-dialog
      ref="dialog"
      :data-for-dialog="tableData.editRow"
      :headers-for-dialog="tableHeaders.dialog"
      :loading="tableData.change.value"
      :spr-data="sprDataForDialog"
      id-name="id"
      @closing-dialog="closeDialog()"
      @dialog-emit="dialogEmits($event)"
      @fetch-new-data="changeOrgTableData($event)">
      <template #title>
        <h2>Добавить запись</h2>
      </template>
      <template #actions="{ close, sendData, loading, validSolo }">
        <div class="d-flex flex-row align-center justify-space-between" style="width: 100%">
          <v-btn class="white__v-btn" @click="close()"> Отменить </v-btn>
          <v-btn :disabled="!validSolo" :loading="loading" class="blue__v-btn" @click="sendData()">
            Сохранить
          </v-btn>
        </div>
      </template>
    </universal-dialog>
    <scans-dialog :letBlocked="getBlock" :show="scanDialog" @close-scan-dialog="scanDialog = false" />
  </div>
</template>

<script>
  import Utils from '@/services/utils';
  import { mapActions, mapGetters } from 'vuex';
  import WrapperPreviewCategory from '@/components/cards/WrapperPreviewCategory';
  import KcpTableHeaders from '@/newApplication/views/tables/KcpTableHeaders';
  import GridTable from '@/components/table/GridTable';
  import UniversalDialog from '@/components/dialog/UniversalDialog';
  import ScansDialog from '@/components/dialog/scansDialog';
  import ShowErrorMessages from '@/components/UI/ShowErrorMessages';
  import { setSprData } from '@/newApplication/mixins/singleTables';
  import {
    changeOrgTableDataWithType,
    deleteOrgTableDataWithType,
    getOrgTableDataWithType,
  } from '@/API/singleTables/tables';

  export default {
    name: 'SingleTable6',
    components: {
      GridTable,
      WrapperPreviewCategory,
      UniversalDialog,
      ScansDialog,
      ShowErrorMessages,
    },
    mixins: [setSprData],
    data: () => ({
      tableHeaders: [],
      tableData: {
        loading: false,
        change: { value: false, id: null },
        error: null,
        editRow: null,
        data: [],
      },
      sprOrg: [],
      excludeMainFF: false,
      chosenFF: null,
      scanDialog: false,
      showErrorModal: false,
      errorMessages: [],
      allowedFfList: [4],
      allowedUslForUgsList: [6],
      selectedYear: '2024',
    }),
    computed: {
      ...mapGetters('keycloak', {
        getUserRoles: 'getUserRoles',
        getUserAccessToken: 'getUserAccessToken',
        getUser: 'getUser',
      }),
      ...mapGetters({ getSelectedYear: 'selectedYear' }),
      getYear() {
        if (this.getSelectedYear) return this.getSelectedYear;
        return this.selectedYear;
      },
      getOrgId() {
        if (this.getFakeUser) return this.getFakeUser.id;
        return this.getUser.orgID;
      },
      letBlocked() {
        return this.getBlock[this.type];
      },
      blockInfo() {
        return this.checkCanBlock[this.type];
      },
      type() {
        return 'PAID_POSTGRADUATE';
      },
      sprDataForDialog() {
        return {
          ...this.sprData,
          sprKcpGroup: Utils.mapSpr(
            this.sprData.sprKcpGroup.filter(
              (el) => el.usl.id === 6 && el.specs.find((el2) => el2.specFlKlasif === 7),
            ),
            'id',
            (el) => {
              return el.code + ' - ' + el.name;
            },
          ),
        };
      },
    },
    watch: {
      $route() {
        this.getOrgTableData();
      },
      type(a, b) {
        if (a !== b) {
          this.tableHeaders = KcpTableHeaders(this);
        }
      },
      getSelectedYear() {
        this.getOrgTableData();
      },
    },
    created() {
      this.getOrgTableData();
      // this.loadSprOrg();
      // this.loadSprKcpGroup();
      // this.loadSprFo();
      // this.loadSprUsl();
      // this.loadSprFf();
      this.tableHeaders = KcpTableHeaders(this);
    },
    methods: {
      ...mapActions('notification', { setNotification: 'setNotification' }),
      closeDialog() {
        this.tableData.editRow = null;
        this.tableData.change = { value: false, id: null };
        this.chosenFF = null;
        this.excludeMainFF = false;
      },
      clickOnRow(e) {
        this.$router.push({
          path: '/mpg',
          query: {
            kcpGroup: e.row.kcpGroupId,
            type: this.type,
            idKcp: e.row.id,
            orgId: e.row.orgId,
            idSprFf: e.row.ffId,
          },
        });
      },
      async dialogEmits(e) {
        if (e.emits === true) {
          if (e.dataField === 'orgId') {
            const item = this.getSprData.org.find((el) => el.id === e[e.variable]);
            this.excludeMainFF = item.id === item.ownerId;
          } else if (e.dataField === 'ffId') {
            this.chosenFF = e[e.variable];
            this.tableData.editRow = await this.$refs['dialog'].formingObjectToSent();
            const ind = this.tableHeaders.dialog.findIndex((el) => el.dataField === 'value');
            if (ind === -1)
              this.tableHeaders.dialog.push({
                text: 'Объем выделенных КЦП на 2024 г./ Места по договорам об оказании платных образовательных услуг',
                dataField: 'value',
                typeVar: 'integer',
                rules: 'customRules',
                customsRulesArray: [
                  (v) =>
                    (this.chosenFF === 1 ? Number.parseInt(v) === 0 : Number.parseInt(v) > 0) ||
                    `${
                      this.chosenFF === 1
                        ? ' Значение должно быть = 0 '
                        : ' Значение должно быть больше 0 '
                    }`,
                  (v) => v != null || 'Значение должно быть выбрано',
                ],
                order: 6,
              });
            else {
              this.tableHeaders.dialog.splice(ind, 1, {
                text: 'Объем выделенных КЦП на 2024 г./ Места по договорам об оказании платных образовательных услуг',
                dataField: 'value',
                typeVar: 'integer',
                rules: 'customRules',
                customsRulesArray: [
                  (v) =>
                    (this.chosenFF === 1 ? Number.parseInt(v) === 0 : Number.parseInt(v) > 0) ||
                    `${
                      this.chosenFF === 1
                        ? ' Значение должно быть = 0 '
                        : ' Значение должно быть больше 0 '
                    }`,
                  (v) => v != null || 'Значение должно быть выбрано',
                ],
                order: 6,
              });
            }
            this.$refs['dialog'].assignedValuesOneStage = await this.$refs[
              'dialog'
            ].assignDataOneStage([], this.dialogHeaders);
            await this.$refs['dialog'].assignEditData();
          }
        }
      },

      async openDialog(type = 'action', row = null) {
        if (type === 'edit') {
          this.tableData.editRow = row;
          const ind = this.tableHeaders.dialog.findIndex((el) => el.dataField === 'value');
          if (ind === -1)
            this.tableHeaders.dialog.push({
              text: 'Объем выделенных КЦП на 2024 г./ Места по договорам об оказании платных образовательных услуг',
              dataField: 'value',
              typeVar: 'integer',
              rules: 'customRules',
              customsRulesArray: [
                (v) =>
                  (this.chosenFF === 1 ? Number.parseInt(v) === 0 : Number.parseInt(v) > 0) ||
                  `${
                    this.chosenFF === 1
                      ? ' Значение должно быть = 0 '
                      : ' Значение должно быть больше 0 '
                  }`,
                (v) => v != null || 'Значение должно быть выбрано',
              ],
              order: 6,
            });
          else {
            this.tableHeaders.dialog.splice(ind, 1, {
              text: 'Объем выделенных КЦП на 2024 г./ Места по договорам об оказании платных образовательных услуг',
              dataField: 'value',
              typeVar: 'integer',
              rules: 'customRules',
              customsRulesArray: [
                (v) =>
                  (this.chosenFF === 1 ? Number.parseInt(v) === 0 : Number.parseInt(v) > 0) ||
                  `${
                    this.chosenFF === 1
                      ? ' Значение должно быть = 0 '
                      : ' Значение должно быть больше 0 '
                  }`,
                (v) => v != null || 'Значение должно быть выбрано',
              ],
              order: 6,
            });
          }
          await this.$refs.dialog.openDialog();
        } else {
          // eslint-disable-next-line no-unused-vars
          const res = this.$refs.dialog.openDialog();
        }
      },
      async getOrgTableData() {
        this.tableData.loading = true;
        this.tableData.error = null;
        // const type = this.$route.query?.type;
        try {
          const res = await getOrgTableDataWithType(this.getOrgId, this.type, this.getYear);
          if (res) this.tableData.data = res;
          this.tableData.loading = false;
        } catch (e) {
          this.tableData.error = e;
          this.tableData.loading = false;
        }
        await this.checkBlockOneType(this.type);
      },
      async changeOrgTableData(row) {
        this.tableData.change = { value: true, id: row.id };
        this.tableData.error = null;
        try {
          const res = await changeOrgTableDataWithType(row, this.getYear);
          if (res) {
            if (row.id) {
              const index = this.tableData.data.findIndex((el) => el.id === row.id);
              this.tableData.data.splice(index, 1, res);
            } else {
              if (res.sprFfId === 1) {
                const index = this.tableData.data.findIndex((el) => el.id === res.id);
                if (index !== -1) this.tableData.data.splice(index + 1, 0, res);
                else this.tableData.data.push(res);
              } else this.tableData.data.push(res);
            }
          }
          this.tableData.change = { value: false, id: row.id };
          await this.$refs.dialog.closeDialog();
        } catch (e) {
          this.tableData.error = e;
          this.tableData.change = { value: false, id: row.id };
        }
        await this.checkBlockOneType(this.type);
      },
      async deleteOrgTableData(row) {
        const agree = confirm('Удалить запись?');
        if (agree) {
          this.tableData.change = { value: true, id: row.id };
          try {
            const res = await deleteOrgTableDataWithType(row.id, this.getYear);
            if (res) {
              this.tableData.change = { value: true, id: row.id };
              const index = this.tableData.data.findIndex((el) => el.id === row.id);
              this.tableData.data.splice(index, 1);
            }
            this.tableData.change = { value: false, id: row.idKcp };
          } catch (e) {
            console.log('e delete', e);
            this.tableData.change = { value: false, id: row.id };
          }
          await this.checkBlockOneType(this.type);
        }
      },
    },
  };
</script>

<style lang="sass">
  .yellow-background
    background-color: #fff3cd
    color: #D4990A

  .section-preview__header
    font-size: 24px
    font-weight: bold
    margin: 16px 0
    color: #334D6E

  .scan-btn
    position: absolute
    right: 30px
    top: 20px

  .block-btn
    position: absolute
    right: 270px
    top: 20px
</style>
